// https://stackoverflow.com/questions/16086162/handle-file-download-from-ajax-post#23797348
export const handleFileDownload = (downloadUrl) => {
	// use HTML5 a[download] attribute to specify filename
	const a = document.createElement('a');
	// safari doesn't support this yet
	if (typeof a.download === 'undefined') {
		window.location = downloadUrl;
	} else {
		a.href = downloadUrl;
		a.download = '';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
};
